import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Users, Target, Sparkles } from "lucide-react";

const seekUrl = (u) => u ? (typeof u === 'string' && u.includes('#') ? u : u + '#t=0.5') : u;


const CasePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Case data - in real app, this would come from CMS or API
  const casesData = {
    "maybach-landaulet-film": {
      videos: ["https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/maybach-landaulet-mit-ton.mp4"],
      title: "Maybach Landaulet Film",
      category: "Luxury Brand Film",
      year: "2024",
      description: "Luxus-Automotive-Produktion auf höchstem Niveau für einen der seltensten Autos der Welt – den Maybach Landaulet (nur 3 Exemplare weltweit). Mit Villa-Location, professionellen Darstellern und cineastischen Aufnahmen in Hechingen und Konstanz.",
      role: "Konzept, Regie, Director of Photography, Edit",
      team: "Darsteller-Ensemble, Location-Team",
      tools: "Cinema Camera Setup, Gimbal, Luxus-Location Hechingen & Konstanz",
      objectives: [
        "Exklusivität und Luxus des Maybach Landaulet visualisieren",
        "Storytelling mit Darstellern und Premium-Locations",
        "Cineastische Bildsprache auf Feature-Film-Niveau",
      ],
      metrics: [
        { label: "Drehorte", value: "2" },
        { label: "Produktionsdauer", value: "3 Tage" },
        { label: "Einzigartigkeit", value: "1 von 3" },
      ],
      testimonial: {
        text: "Kenny hat es geschafft, die Exklusivität und den Luxus des Maybach Landaulet perfekt einzufangen. Eine Produktion auf absolutem Top-Niveau.",
        author: "Fahrzeugbesitzer",
        company: "Maybach Landaulet",
      },
      bts: {
        videos: [
          {
            url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/maybach-landaulet.mp4",
            format: "9:16"
          },
          {
            url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/maybach-landaulet-bts-2.mp4",
            format: "9:16"
          }
        ]
      },
    },
    "geiger-group": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/geiger-kunedzufriedenheit-fuer-die-em-2024.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/geiger-gmbh-wir-retten-nicht-nur-beziehungen.mp4"
      ],
      title: "Geiger Group - Langjährige Partnerschaft",
      category: "Corporate Campaign",
      year: "2024",
      description: "Langjährige Zusammenarbeit mit der Geiger Group (Identica) – Karosserie- und Lackexperten. Von Kundenzufriedenheits-Kampagnen bis zur EM 2024 Kampagne: Kreative Corporate Videos mit Humor und Botschaft.",
      role: "Konzept, Regie, Kamera, Edit",
      team: "Geiger Marketing-Team, Mitarbeiter",
      tools: "Sony A7S III, Lighting Setup, DaVinci Resolve",
      objectives: [
        "Kundenzufriedenheit emotional transportieren",
        "EM 2024 Kampagne: 'Wir retten nicht nur Beziehungen'",
        "Markenpersönlichkeit authentisch zeigen",
      ],
      metrics: [
        { label: "Jahre Partnerschaft", value: "5+" },
        { label: "Videos produziert", value: "15+" },
        { label: "Kundenbindung", value: "+40%" },
      ],
      testimonial: {
        text: "Kenny versteht unsere Marke und setzt sie perfekt in Szene. Die Videos haben uns geholfen, unsere Kundenzufriedenheit deutlich zu steigern.",
        author: "Marketing Director",
        company: "Geiger Group / Identica",
      },
      bts: {
        videos: [
          {
            url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/geiger-group-bts.mp4",
            format: "9:16"
          },
          {
            url: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/geiger-bts-1.mp4",
            format: "16:9"
          }
        ]
      },
    },
    "dubai-reel-package": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/tag-3-gt3-rs-berge-2.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/urus-blau-dubai.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/cullinan-dubai-skyline.mp4"
      ],
      title: "Dubai Luxury Cars",
      category: "Social Content",
      year: "2024",
      description: "15–20 hochwertige Reels für eine Luxus-Autovermietung in Dubai. Porsche GT3 RS, Lamborghini Urus, Rolls-Royce Cullinan – in atemberaubenden Locations. Schnelle Postproduktion und Creator-Cuts für maximale Social-Media-Reichweite.",
      role: "Konzept, Dreh, Schnitt, Color Grading",
      team: "Solo-Produktion mit lokalem Fixer",
      tools: "Sony FX3, DJI Ronin, Freycreate (Styleframes & Versioning)",
      objectives: [
        "Content für 3 Monate Social Media",
        "Vertikale 9:16 Formate für Social Media",
        "Schnelle Turnaround-Zeit",
      ],
      metrics: [
        { label: "Reels produziert", value: "18" },
        { label: "Gesamt-Views", value: "2.3M+" },
        { label: "Engagement-Rate", value: "8.2%" },
      ],
      testimonial: {
        text: "Kenny hat in kürzester Zeit erstklassigen Content geliefert. Die Reels performen außerordentlich gut.",
        author: "Marketing Director",
        company: "Client Name",
      },
      bts: {
        video: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/img-1800-2.mp4",
        photos: [
          "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/kuir5poh-dsc9914.jpeg",
          "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/0idinuj5-dsc9608.jpeg",
          "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/oi5te1r3-dsc9454.jpg",
          "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/images/edeei6cs-dsc9771.jpeg"
        ]
      },
    },
    "stadt-villingen-schwenningen": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/vs-weihnachtmaerkte-rueckblick-2024.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/stadt-wochemarkt-video-1.mp4"
      ],
      title: "Stadt Villingen-Schwenningen",
      category: "City Campaign",
      year: "2023-2024",
      description: "Imagefilme und Bewerbungsvideos für die Weihnachts- und Wochenmärkte der Stadt Villingen-Schwenningen. Atmosphärische Aufnahmen, die Besucher anziehen.",
      role: "Creative Direction, Kamera, Schnitt",
      team: "Stadt VS Marketing-Team",
      tools: "Sony A7S III, Gimbal, Drohne, DaVinci Resolve",
      objectives: [
        "Mehr Stimmung, mehr Besucher",
        "6 Video-Assets von Impression bis Bewerbungs-Cut",
        "Optimiert für 16:9 & 9:16",
      ],
      metrics: [
        { label: "Videos produziert", value: "6" },
        { label: "Reichweite", value: "500K+" },
        { label: "Besuchersteigerung", value: "+15%" },
      ],
      testimonial: {
        text: "Die Videos haben genau die richtige Atmosphäre eingefangen. Wir konnten eine deutliche Steigerung der Besucherzahlen verzeichnen.",
        author: "Stadtmarketing",
        company: "Stadt Villingen-Schwenningen",
      },
    },
    "startup-foerderung-vs": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/01-maedchen-film01-16-9.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/02-maedchen-film03-16-9.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/03-maedchen-reel-9-16.mp4"
      ],
      title: "Startup-Förderung VS",
      category: "Campaign",
      year: "2024",
      description: "Kampagne zur Förderung von Startups in Villingen-Schwenningen. Die Geschichte einer jungen Gründerin: vom kleinen Saftstand, wo alles schief läuft, zur eigenen erfolgreichen Saftbar – dank der START UP. VS Förderung. In Zusammenarbeit mit Daniel Hofmeier.",
      role: "Co-Produktion: Regie, Kamera, Edit",
      team: "Daniel Hofmeier (Partner), Startup-Coaches, Darstellerin",
      tools: "Cinema Camera Setup, Freycreate Previz, Adobe Premiere",
      objectives: [
        "Startup-Ecosystem sichtbar machen",
        "Gründer motivieren und informieren",
        "Multi-Channel Distribution",
      ],
      metrics: [
        { label: "Hero-Videos", value: "4" },
        { label: "Anmeldungen", value: "+120" },
        { label: "Social Reach", value: "800K+" },
      ],
      testimonial: {
        text: "Professionelle Umsetzung, die unsere Vision perfekt transportiert hat. Die Zusammenarbeit war erstklassig.",
        author: "Projektleitung",
        company: "Wirtschaftsförderung VS",
      },
      bts: {
        video: "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/retro-vibes-15.mp4",
        photos: []
      },
    },
    "corporate-recruiting": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/fiehn-recruting-reel.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/servicemitarbeiter-mwd.mp4"
      ],
      title: "Corporate & Recruiting Videos",
      category: "Corporate Video",
      year: "2024",
      description: "Professionelle Recruiting- und Imagevideos für Unternehmen zur Mitarbeitergewinnung. Authentische Darstellung der Arbeitgeber-Marke mit emotionalen Geschichten.",
      role: "Konzept, Regie, Kamera, Edit",
      team: "HR-Teams & Mitarbeiter",
      tools: "Sony A7S III, Interview-Setup, Natural Lighting",
      objectives: [
        "Authentische Arbeitgeber-Darstellung",
        "Emotionale Mitarbeiter-Stories",
        "Social-Media optimiert für Recruiting-Kampagnen",
      ],
      metrics: [
        { label: "Videos produziert", value: "10+" },
        { label: "Bewerbungen", value: "+65%" },
        { label: "Engagement-Rate", value: "15%" },
      ],
      testimonial: {
        text: "Die Recruiting-Videos haben unsere Bewerberzahlen deutlich gesteigert. Authentisch und emotional – genau das, was wir brauchten.",
        author: "HR Director",
        company: "Fiehn Automobile",
      },
    },
    "seedos-product-campaign": {
      videos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-allgemein.mp4"
      ],
      additionalVideos: [
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-der-snack-der-dich-findet.mp4",
        "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev/videos/seedos-salted.mp4"
      ],
      title: "Seedos Product Campaign",
      category: "Product & Brand",
      year: "2024",
      description: "Social Content & Produktfilm für Seedos – einen innovativen Sonnenblumenkerne-Hersteller mit Geschmack. Von der Produktinszenierung bis zu viralen Reels für maximale Reichweite.",
      role: "Konzept, Regie, Kamera, Edit",
      team: "Seedos Marketing-Team",
      tools: "Sony A7S III, Product Setup, Freycreate (Styleframes)",
      objectives: [
        "Produktvorstellung mit hoher Anziehungskraft",
        "Social-First Content für TikTok & Instagram",
        "Brand Awareness aufbauen",
      ],
      metrics: [
        { label: "Videos produziert", value: "3" },
        { label: "Social Reach", value: "1.2M+" },
        { label: "Engagement-Rate", value: "12.5%" },
      ],
      testimonial: {
        text: "Die Videos haben unsere Marke perfekt zum Leben erweckt. Die Reels performen außergewöhnlich gut auf Social Media.",
        author: "Marketing Director",
        company: "Seedos",
      },
    },
  };

  const caseData = casesData[slug];

  if (!caseData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Case nicht gefunden</h2>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-[hsl(var(--accent))] text-white rounded-xl hover:bg-[hsl(var(--accent))]/90"
          >
            Zurück zur Startseite
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="case-page">
      {/* Hero Video */}
      <section className="relative h-[70vh] overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={seekUrl(caseData.videos?.[0] || caseData.video)} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-background"></div>
        
        {/* Back button */}
        <button
          onClick={() => navigate('/')}
          className="absolute top-8 left-8 z-10 px-4 py-2 bg-black/50 backdrop-blur-sm hover:bg-black/70 text-white rounded-xl flex items-center gap-2 transition-all"
          data-testid="back-button"
        >
          <ArrowLeft className="w-5 h-5" />
          Zurück
        </button>
      </section>

      {/* Case Details */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
          {/* Header */}
          <div className="mb-12">
            <div className="flex items-center gap-4 mb-4">
              <span className="px-3 py-1 text-sm font-medium bg-[hsl(var(--accent))]/20 text-[hsl(var(--accent))] rounded-full">
                {caseData.category}
              </span>
              <span className="text-muted-foreground">{caseData.year}</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold mb-4" data-testid="case-title">{caseData.title}</h1>
            <p className="text-xl text-muted-foreground leading-relaxed">{caseData.description}</p>
          </div>

          {/* Additional Videos (if more than 1) */}
          {caseData.videos && caseData.videos.length > 1 && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6">Weitere Videos</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {caseData.videos.slice(1).map((video, index) => (
                  <div key={index} className="aspect-video bg-secondary rounded-xl overflow-hidden">
                    <video controls preload="metadata" className="w-full h-full object-cover">
                      <source src={seekUrl(video)} type="video/mp4" />
                    </video>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Additional Videos with 9:16 format (for Seedos case) */}
          {caseData.additionalVideos && caseData.additionalVideos.length > 0 && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6">Weitere Videos</h2>
              <div className="grid md:grid-cols-2 gap-6">
                {caseData.additionalVideos.map((video, index) => (
                  <div key={index} className="aspect-[9/16] bg-secondary rounded-xl overflow-hidden mx-auto max-w-sm">
                    <video controls preload="metadata" className="w-full h-full object-cover">
                      <source src={seekUrl(video)} type="video/mp4" />
                    </video>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* BTS Section */}
          {caseData.bts && (
            <div className="mb-12">
              <h2 className="text-2xl font-bold mb-6">Behind the Scenes</h2>
              <p className="text-muted-foreground mb-6">
                Einblicke in die Produktion
              </p>
              
              {/* Multiple BTS Videos */}
              {caseData.bts.videos && caseData.bts.videos.length > 0 ? (
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  {caseData.bts.videos.map((btsVideo, index) => {
                    const videoFormat = btsVideo.format === '9:16' ? 'aspect-[9/16]' : 'aspect-video';
                    const containerClass = btsVideo.format === '9:16' ? 'mx-auto max-w-sm' : '';
                    
                    return (
                      <div key={index} className={`${videoFormat} ${containerClass} bg-secondary rounded-xl overflow-hidden`}>
                        <video controls preload="metadata" className="w-full h-full object-cover">
                          <source src={seekUrl(btsVideo.url)} type="video/mp4" />
                        </video>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="grid md:grid-cols-2 gap-6 mb-6">
                  {/* Single BTS Video (backward compatibility) */}
                  {caseData.bts.video && (
                    <div className="aspect-[9/16] md:aspect-video bg-secondary rounded-xl overflow-hidden">
                      <video controls preload="metadata" className="w-full h-full object-cover">
                        <source src={seekUrl(caseData.bts.video)} type="video/mp4" />
                      </video>
                    </div>
                  )}
                  
                  {/* BTS Photos Grid */}
                  {caseData.bts.photos && (
                    <div className="grid grid-cols-2 gap-4">
                      {caseData.bts.photos.map((photo, index) => (
                        <div key={index} className="aspect-[3/2] bg-secondary rounded-xl overflow-hidden hover:scale-105 transition-transform cursor-pointer">
                          <img src={photo} alt={`BTS ${index + 1}`} className="w-full h-full object-cover" />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Project Info Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-secondary/30 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <Target className="w-5 h-5 text-[hsl(var(--accent))]" />
                <h3 className="font-semibold">Rolle</h3>
              </div>
              <p className="text-muted-foreground text-sm">{caseData.role}</p>
            </div>
            <div className="bg-secondary/30 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <Users className="w-5 h-5 text-[hsl(var(--accent))]" />
                <h3 className="font-semibold">Team</h3>
              </div>
              <p className="text-muted-foreground text-sm">{caseData.team}</p>
            </div>
            <div className="bg-secondary/30 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <Sparkles className="w-5 h-5 text-[hsl(var(--accent))]" />
                <h3 className="font-semibold">Tools</h3>
              </div>
              <p className="text-muted-foreground text-sm">{caseData.tools}</p>
            </div>
          </div>

          {/* Objectives */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-6">Projektziele</h2>
            <ul className="space-y-3">
              {caseData.objectives.map((objective, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[hsl(var(--accent))]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 rounded-full bg-[hsl(var(--accent))]"></div>
                  </div>
                  <span className="text-muted-foreground">{objective}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Metrics */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-6">Kennzahlen</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {caseData.metrics.map((metric, index) => (
                <div key={index} className="bg-secondary/30 rounded-2xl p-6 text-center">
                  <div className="text-4xl font-bold mb-2 neon-text text-[hsl(var(--accent))]">
                    {metric.value}
                  </div>
                  <div className="text-sm text-muted-foreground">{metric.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-secondary/30 rounded-2xl p-8 md:p-12">
            <div className="text-4xl text-[hsl(var(--accent))] mb-4">“</div>
            <p className="text-lg md:text-xl mb-6 leading-relaxed">{caseData.testimonial.text}</p>
            <div>
              <div className="font-semibold">{caseData.testimonial.author}</div>
              <div className="text-sm text-muted-foreground">{caseData.testimonial.company}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CasePage;
